import React from 'react';
import './HomeAdmin.css';
import AdminNavbar from './AdminNavbar';

const HomeAdmin = () => {
  return (
    <div className="home-container">
      <AdminNavbar />

      <main className="main-content">
        <div className="home-welcome">
          <h2>Selecciona una opción del menú para comenzar</h2>
          <p>Las páginas de gestión (Noticias, Autores, Categorías) se abrirán en sus rutas correspondientes.</p>
        </div>
      </main>

      <footer className="footer">
        <div className="footer-links">
          <a href="#privacidad">Política de Privacidad</a>
          <a href="#terminos">Términos y Condiciones</a>
          <a href="#contacto">Contacto</a>
        </div>
        <p className="footer-text">© 2025 Panel de Administrador. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default HomeAdmin;
